import { getSessionId, getSessionStartTime, saveCurrentStep, getAuthXToken } from '@/services/auth'
import { NR_MFA_OTP_AUTHENTICATION, NR_STEPS, NR_LOGIN_STEP, EMAIL_DOMAIN_SITEMINDER } from './constants'

/**
 * Tracks MFA OTP authentication step in New Relic and updates session state.
 * Records the step progression and calculates duration from session start.
 */
export const nrMfaOtpAuthentication = (): boolean => {
  try {
    const authxToken = getAuthXToken()

    if (authxToken.payload.email.includes(EMAIL_DOMAIN_SITEMINDER)) {
      return false
    }

    const sessionId = getSessionId()
    const sessionStartTime = getSessionStartTime()

    const newrelic: any = (window as any).newrelic

    // Guard against invalid session start time
    if (!sessionStartTime || isNaN(Number(sessionStartTime))) {
      return false
    }

    const duration = Date.now() - Number(sessionStartTime)

    if (newrelic && sessionId) {
      newrelic.addPageAction(NR_LOGIN_STEP, { sessionId, step: NR_STEPS.MFA_OTP_AUTHENTICATION })
      newrelic.addPageAction(NR_MFA_OTP_AUTHENTICATION, { sessionId, durationMs: duration })
      saveCurrentStep(NR_STEPS.MFA_OTP_AUTHENTICATION)
      return true
    }

    return false
  } catch {
    return false
  }
}
